import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import Header from './components/Header6';
import Footer from './components/Footer6';

const Login6 = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template6');
    };

    const inputStyle = "w-full px-4 py-3.5 bg-[#FAF7F2] border border-[#D4C5B0] text-[#2C1810] text-sm rounded-sm outline-none transition-colors duration-300 focus:border-[#8B4513] placeholder-[#7C6B5D]";

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@400;600;700&family=Nunito:wght@300;400;600&display=swap');
            `}</style>
            <div style={{ fontFamily: "'Nunito', -apple-system, sans-serif" }} className="min-h-screen bg-[#F5F0E8]">
                <Header />

                <main className="pt-20 min-h-screen flex">
                    {/* Left Side - Hero Image (Desktop Only) */}
                    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
                        <img src="https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Handloom heritage" className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-r from-[#3B1A08]/30 via-[#3B1A08]/50 to-[#F5F0E8]" />
                        <div className="relative z-10 flex flex-col justify-center items-start p-16 max-w-lg">
                            <div className="w-12 h-px bg-[#8B4513] mb-6" />
                            <h2 style={{ fontFamily: "'Noto Serif Display', serif" }} className="text-4xl xl:text-5xl font-normal text-[#F5F0E8] leading-tight mb-4">
                                Welcome Back to the Loom
                            </h2>
                            <p className="text-[#D4C5B0] text-base leading-relaxed" style={{ fontWeight: 300 }}>
                                Step back into the warmth of handcrafted Indian textiles. Your favourites await.
                            </p>
                        </div>
                    </div>

                    {/* Right Side - Login Form */}
                    <div className="flex-1 flex items-center justify-center px-6 py-12 lg:py-0">
                        <div className="w-full max-w-md">
                            <div className="text-center mb-10">
                                <h1 onClick={() => navigate('/template6')} style={{ fontFamily: "'Noto Serif Display', serif" }} className="text-3xl font-bold text-[#8B4513] cursor-pointer tracking-[3px] mb-3">
                                    DHARTI
                                </h1>
                                <h2 style={{ fontFamily: "'Noto Serif Display', serif" }} className="text-2xl lg:text-3xl font-normal text-[#2C1810] tracking-wide">
                                    Welcome Back
                                </h2>
                                <p className="text-[#7C6B5D] text-sm mt-2" style={{ fontWeight: 300 }}>
                                    Sign in to access your account and handloom collections
                                </p>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-5">
                                <div>
                                    <label className="block text-xs font-semibold text-[#2C1810] mb-2 uppercase tracking-[1px]">Email</label>
                                    <div className="relative">
                                        <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#7C6B5D]" />
                                        <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="your@email.com" required className={inputStyle} style={{ paddingLeft: '44px', fontFamily: "'Nunito', sans-serif" }} />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-xs font-semibold text-[#2C1810] mb-2 uppercase tracking-[1px]">Password</label>
                                    <div className="relative">
                                        <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#7C6B5D]" />
                                        <input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={handleInputChange} placeholder="Enter your password" required className={inputStyle} style={{ paddingLeft: '44px', paddingRight: '44px', fontFamily: "'Nunito', sans-serif" }} />
                                        <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-[#7C6B5D] hover:text-[#8B4513]" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </button>
                                    </div>
                                </div>

                                <div className="flex justify-between items-center">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" style={{ accentColor: '#8B4513' }} />
                                        <span className="text-sm text-[#7C6B5D]" style={{ fontWeight: 300 }}>Remember me</span>
                                    </label>
                                    <span className="text-sm text-[#8B4513] cursor-pointer hover:text-[#6B3410] font-semibold">Forgot Password?</span>
                                </div>

                                <button type="submit" className="w-full" style={{ padding: '16px', backgroundColor: '#8B4513', color: '#FFFFFF', border: 'none', borderRadius: '2px', fontSize: '13px', fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Nunito', sans-serif", transition: 'background-color 0.3s' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#6B3410')}
                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#8B4513')}>
                                    Sign In
                                </button>
                            </form>

                            <p className="text-center mt-8 text-sm text-[#7C6B5D]" style={{ fontWeight: 300 }}>
                                New to Dharti?{' '}
                                <span onClick={() => navigate('/template6/signup')} className="text-[#8B4513] font-semibold cursor-pointer hover:text-[#6B3410]">Create an Account</span>
                            </p>
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Login6;
